import { render, staticRenderFns } from "./KeyMedia.vue?vue&type=template&id=18ce9863&scoped=true&"
import script from "./KeyMedia.vue?vue&type=script&lang=ts&"
export * from "./KeyMedia.vue?vue&type=script&lang=ts&"
import style0 from "./KeyMedia.vue?vue&type=style&index=0&id=18ce9863&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ce9863",
  null
  
)

export default component.exports